import { InjectionKey, inject } from "vue";
import currencyjs from "currency.js";
import { SnackbarType } from "@/util/snack-bar";
import { CircularLoaderType } from "@/util/progress-circular-loader";
import { AxiosInstance } from 'axios'
//create a type for type inference
type currencyType = typeof currencyjs;

const SnackbarKey: InjectionKey<SnackbarType> = Symbol("Snackbar");
const CircularLoaderKey: InjectionKey<CircularLoaderType> = Symbol("CircularLoader");
const CurrencyJSKey: InjectionKey<currencyType> = Symbol("Currency") as InjectionKey<currencyType>;
const AxiosKey: InjectionKey<AxiosInstance> = Symbol("AxiosInstance");

function injectStrict<T>(key: InjectionKey<T>, fallback?: T) {
  const resolved = inject(key, fallback);
  if (!resolved) {
    throw new Error(`Could not resolve ${key.description}`);
  }
  return resolved;
}

export {
  injectStrict,
  SnackbarKey,
  CircularLoaderKey,
  CurrencyJSKey,
  AxiosKey,
};